export const SECTION_LOGO = 'SECTION_LOGO';
export const SECTION_ABN = 'SECTION_ABN';
export const SECTION_CLASSIFICATION = 'SECTION_CLASSIFICATION';
export const SECTION_TRANSACTIONS = 'SECTION_TRANSACTIONS';
export const SECTION_CHART= 'SECTION_CHART';
export const SECTION_BUDGET = 'SECTION_BUDGET';
export const SECTION_REVOLUT = 'SECTION_REVOLUT';
export const SECTION_ICS = 'SECTION_ICS';
export const SECTION_SWIBECO = 'SECTION_SWIBECO';
export const SECTION_CREDIT_AGRICOLE = 'SECTION_CREDIT_AGRICOLE';
export const SECTION_CREDIT_MUTUEL_EUR = 'SECTION_CREDIT_MUTUEL_EUR';
export const SECTION_CREDIT_MUTUEL_CHF = 'SECTION_CREDIT_MUTUEL_CHF';
export const SECTION_REPORTING = 'SECTION_REPORTING';
export const SECTION_BAF = 'SECTION_BAF';
export const SECTION_CATEGORIES = 'SECTION_CATEGORIES';
export const SECTION_SETTINGS = 'SECTION_SETTINGS';
export const SECTION_BUNQ = 'SECTION_BUNQ';
export const SECTION_ASN = 'SECTION_ASN';
export const SECTION_UBS = 'SECTION_UBS';
export const SECTION_ABOUT = 'SECTION_ABOUT';


export const SECTION_HISTORY = 'SECTION_HISTORY';